<template>
  <b-form class="p-2">
    <b-form-group label-cols="2" label="Niveau">
      <b-form-checkbox-group
          :value="value.niveau"
          @input="input('niveau',$event)"
          :options="options"
          style="padding: 7px 5px"/>
    </b-form-group>
    <b-form-group label-cols="2" label="Tags">
      <vue-select
          :value="value.tags"
          @input="input('tags',$event)"
          :options="tags"
          multiple></vue-select>
    </b-form-group>
  </b-form>
</template>

<script>
import {DataFormat} from "@/js/utils";
import VueSelect from "vue-select"

export default {
  name: "SearchFilter",
  components: {VueSelect},
  props: {
    tags: {
      type: Array, default() {
        return []
      }
    },
    value: {
      type: Object, default() {
        return {}
      }
    }
  },
  data() {
    return {
      options: [...DataFormat.Exercices.Options.Niveau].reverse().slice(2),
      Label: "Niveaux"
    }
  },
  methods: {
    input(key, data) {
      this.value[key] = data
      this.$emit('input', this.value)
    }
  }
}
</script>

<style scoped>

</style>